module.exports = __webpack_public_path__ + "img/jgsb.73466b48.png";